import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconRotate360Off = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M12 7.00002C6.29883 7.00002 2 9.14943 2 12C2 14.114 4.36377 15.8652 8.04272 16.6142L6.29296 18.3643L7.70702 19.7783L11.9492 15.5357L7.70702 11.293L6.29296 12.707L8.1704 14.5847C5.56359 13.9976 3.99999 12.8966 3.99999 12C3.99999 10.7769 7.1162 9.00001 12 9.00001C16.8838 9.00001 20 10.7769 20 12C20 13.1361 17.5825 14.5058 14 14.8912V16.9066C18.7568 16.4617 22 14.5061 22 12C22 9.14941 17.7012 7 12 7L12 7.00002Z" }))));
};
